import { flatten } from 'lodash';

import { getAddonsForTicket } from 'hb-react/shared/apps/Events/utils/getAddonsForTicket';
import { getTicketInformation } from 'hb-react/shared/apps/Events/utils/getTicketInformation';

const toCents = (price) => parseInt(price * 100, 10);

export const sumTicketsWithAddons = ({
  selectedTickets = [],
  availableTickets,
  attendees,
}) => {
  const getSelectedAddons = getAddonsForTicket(attendees);

  return flatten(
    selectedTickets
      .filter(({ quantity }) => Number(quantity) > 0)
      .map(({ id, quantity }) => ({
        ...getTicketInformation({ tickets: availableTickets }, id),
        quantity,
        addons: getSelectedAddons(id),
      }))
      .filter((ticket) => ticket.id)
      .map(({ price, quantity, addons }) => [
        { price, quantity },
        ...addons.map(({ price, quantity }) => ({ price, quantity })),
      ]),
  ).reduce(
    (total, { price, quantity }) => toCents(price) * quantity + total,
    0,
  );
};

export const sumAddonsInCents = ({ addons = [] }) =>
  addons
    .filter(({ quantity }) => Number(quantity) > 0)
    .reduce((total, { price }) => toCents(price) + total, 0);

export const sumDonationsInCents = ({ donations = [] }) =>
  donations
    .filter(({ amount }) => Number(amount) > 0)
    .reduce((total, { amount }) => toCents(amount) + total, 0);

export const computeTotalPrice = ({
  selectedTickets,
  availableTickets,
  attendees,
  addons,
  donations,
}) => {
  const ticketsWithAddons = sumTicketsWithAddons({
    selectedTickets,
    availableTickets,
    attendees,
    donations,
  });

  const totalAddons = sumAddonsInCents({ addons });

  const totalDonations = sumDonationsInCents({ donations });

  const TotalPriceInCents = ticketsWithAddons + totalAddons + totalDonations;

  return TotalPriceInCents / 100;
};
